import AutoComplete from "components/common/AutoComplete";
import DropdownSelect from "components/common/DropdownSelect";
import serialize from "form-serialize";
import QuoteSalesOrder from "interfaces/QuoteSalesOrder";
import * as moment from "moment";
import * as React from "react";
import Select from 'react-select';
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import apifetch from "utils/apifetch";
import extractErrorMessage from "utils/extractErrorMessage";
import normalizePhone from "utils/normalizePhone";
import { DangerAlert } from "components/common/Alerts";
import JobCustomerAddress from "../../interfaces/JobCustomerAddress";
import SalesPerson from "../../interfaces/SalesPerson";

interface Props {
    onSubmit: Function;
    onCancel: Function;
    isDraft: boolean;
    data: QuoteSalesOrder;
    defaultSalesTaxRate?: number;
}

interface State {
    isAdd: boolean;
    data: QuoteSalesOrder;
    cityStateZip: Array<{
        city: string;
        state: string;
        zipCode: string;
        taxRegionName: string;
        estimatedCombinedRate: number;
        stateRate: number;
        estimatedCountyRate: number;
        estimatedCityRate: number;
        estimatedSpecialRate: number;
        riskLevel: number;
    }>;

    hasValidationErrors: boolean;
    errorMessage?: string;
    isTaxable: boolean | undefined;
    salespeople: SalesPerson[];
    selectedSalespersonCode?: string;
    isJobSelected: boolean;
    selectedJobCustomerAddress?: JobCustomerAddress | null;
    isYardPickup: boolean;
}

interface Data {
    quoteName?: string;
    shippingMethod: string;
    shippingMethodYard: string;
    salesTax: string | number;
    salesTaxRate: string | number;
}

export default class SalesOrderStep1 extends React.Component<Props, State> {

    private formRef: React.RefObject<HTMLFormElement>;
    private timeoutId: number | null = null;

    constructor(props: Props) {
        super(props);

        this.state = {
            isAdd: !(this.props.data && this.props.data.date),
            hasValidationErrors: false,
            errorMessage: undefined,
            data: this.props.data,
            cityStateZip: this.props.data.cityStateZip == undefined ? [] : this.props.data.cityStateZip,
            isTaxable: this.props.data.isTaxable,
            salespeople: [],
            selectedSalespersonCode: this.props.data.salespersonCode || '',
            isJobSelected: false,
            selectedJobCustomerAddress: this.props.data.jobCustomerAddress || null,
            isYardPickup: this.props.data.isYardPickup == undefined ? true : this.props.data.isYardPickup,
        };

        this.formRef = React.createRef();

        this.handleSubmit = this.handleSubmit.bind(this);
        this.groupBy = this.groupBy.bind(this);
        this.handleCancel = this.handleCancel.bind(this);

        this.handleShippingMethodChanged =
            this.handleShippingMethodChanged.bind(this);
        this.handleShippingMethodYardChanged =
            this.handleShippingMethodYardChanged.bind(this);
        this.doNothing = this.doNothing.bind(this);
        this.handleShippingCitySelected =
            this.handleShippingCitySelected.bind(this);
        this.handleBooleanInputChanged = this.handleBooleanInputChanged.bind(this);
        this.handleSalespersonChanged = this.handleSalespersonChanged.bind(this);
        this.handleJobChanged = this.handleJobChanged.bind(this);
        this.handleJobAddressChange = this.handleJobAddressChange.bind(this);
        this.handleJobCitySelected = this.handleJobCitySelected.bind(this);
    }

    default() {
        throw new Error("Method not implemented.");
    }

    public render() {
        const percentageMask = createNumberMask({
            prefix: "",
            suffix: "%",
            allowDecimal: true,
            decimalLimit: 4,
        });

        let quoteId = this.props.data.quoteId.toString();
        if (this.props.data.isMaster) {
            quoteId += "M";
        }
        if (this.props.data.revisionDate) {
            quoteId += ", rev " + moment(this.props.data.revisionDate).format("l");
        }
        if (this.props.data.isDraft) {
            quoteId += " (Draft)";
        }

        const projectOptions = this.state.data.jobCustomerAddresses.map((value) => ({
            value: value.jobId,
            label: value.jobName,
        }));

        return (
            <div>
                <div className="tab-bar mb-4 pb-3">
                    <p className="tab-bar__step-info text-right">Step 1 of 2</p>
                    <p className="direct-vendor__steps tab-bar__step-info text-right">
                        Step 1 of 3
                    </p>
                    <ul className="tab-bar__list">
                        <li className="active">
                            <a href="#" onClick={(event) => this.doNothing(event)}>
                                Sales Order Details
                            </a>
                        </li>
                        <li className="tab-bar__list-material no-right-border disabled">
                            <a href="#" onClick={(event) => this.doNothing(event)}>
                                Material Details
                            </a>
                        </li>
                        {this.state.data.shippingMethod === "direct" && (
                            <li className="triggerSleepingDirect disabled">
                                <a href="#" onClick={(event) => this.doNothing(event)}>
                                    Vendor Details
                                </a>
                            </li>
                        )}
                    </ul>
                </div>
                <div className="box-wrap">
                    <form
                        autoComplete="off"
                        onSubmit={this.handleSubmit}
                        ref={this.formRef}
                    >
                        {this.state.data.id > 0 && (<h2 className="card__title">Edit Sales Order</h2>)}
                        {this.state.data.id === 0 && (<h2 className="card__title">Add Sales Order</h2>)}
                        {this.state.errorMessage && (
                            <DangerAlert name="dangerAlert">{this.state.errorMessage}</DangerAlert>
                        )}
                        <div className="box">
                            <div className="row">
                                <div className="customQuoteSelectTrigger">
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Quote</span>
                                        <span className="field-item">
                                            {this.state.data.quoteName}
                                        </span>
                                    </div>
                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Quote ID</span>
                                        <span className="field-item">{quoteId}</span>
                                    </div>

                                    <div className="row">
                                        {this.state.data.customers.map((item, index) => (
                                            <>
                                                <div className="field-group col-sm-12 d-flex flex-wrap mb-2">
                                                    <div className="field-group col-sm-6">
                                                        <span className="field-label">Customer Name</span>
                                                        <span className="field-item">
                                                            {item.customerName} ({item.customerApiType === 1 ? "BC" : SITE_NAME})
                                                        </span>
                                                        <input
                                                            type="hidden"
                                                            name="customerName"
                                                            value={item.customerName}
                                                        />
                                                    </div>
                                                    <div className="field-group col-sm-6">
                                                        <span className="field-label">Customer ID</span>
                                                        <span className="field-item">
                                                            {item.customerId}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div className="field-group col-sm-12  d-flex flex-wrap">
                                                    <div className="field-group col-sm-6">
                                                        <span className="field-label">
                                                            Customer Contact
                                                        </span>
                                                        <div>
                                                            <input
                                                                type="text"
                                                                name="customerContactName"
                                                                className="form-control"
                                                                defaultValue={item.customerContactName}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="field-group col-sm-6">
                                                        <span className="field-label">Phone</span>
                                                        <div>
                                                            <div className="react-datepicker-wrapper" style={{ display: "block" }}>
                                                                <div className="react-datepicker__input-container" style={{ display: "block" }}>
                                                                    <MaskedInput
                                                                        mask={[
                                                                            "(",
                                                                            /[1-9]/,
                                                                            /\d/,
                                                                            /\d/,
                                                                            ")",
                                                                            " ",
                                                                            /\d/,
                                                                            /\d/,
                                                                            /\d/,
                                                                            "-",
                                                                            /\d/,
                                                                            /\d/,
                                                                            /\d/,
                                                                            /\d/,
                                                                        ]}
                                                                        name="phone"
                                                                        className="form-control"
                                                                        placeholder="(xxx) xxx-xxxx"
                                                                        pattern="\(\d{3}\) \d{3}-\d{4}"
                                                                        onInput={(e) =>
                                                                            e.currentTarget.setCustomValidity("")
                                                                        }
                                                                        onInvalid={(e) =>
                                                                            e.currentTarget.setCustomValidity(
                                                                                "Phone number must be in the format of (xxx) xxx-xxxx."
                                                                            )
                                                                        }
                                                                        defaultValue={item.phone}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ))}
                                    </div>

                                    <div className="field-group col-sm-12">
                                        <span className="field-label">Project Name</span>
                                        <Select
                                            name="projectId"
                                            className="w-80"
                                            value={projectOptions.find(option => option.value === this.state.data.jobId)}
                                            onChange={this.handleJobChanged}
                                            options={projectOptions}
                                            searchable
                                            placeholder="Select a project"
                                        />
                                    </div>

                                    <div className="row">
                                        <div className="field-group col-sm-12 d-flex flex-wrap mb-2">
                                            <div className="field-group col-sm-6">
                                                <span className="field-label">Project Address</span>

                                                <div>
                                                    <input
                                                        type="text"
                                                        role="presentation"
                                                        name="jobAddress"
                                                        className="form-control"
                                                        value={this.state.data.jobAddress || ""}
                                                        readOnly={this.state.isYardPickup}
                                                        onChange={this.handleJobAddressChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="field-group col-sm-6">
                                                <span className="field-label">City</span>
                                                <div style={{
                                                    width: "68%",
                                                    display: "block",
                                                    float: "left"
                                                }}>
                                                    <AutoComplete
                                                        name="jobCity"
                                                        onChange={this.handleJobCitySelected}
                                                        value={this.state.data.jobCity || ""}
                                                        readOnly={this.state.isYardPickup}
                                                        onClick={(e) => {
                                                            if (!!e.currentTarget.innerText) {

                                                                const elements = document.getElementsByName('jobCity');
                                                                Array.from(elements).forEach(element => {
                                                                    element.style.boxShadow = '';
                                                                });

                                                                const valueCity =
                                                                    e.currentTarget.innerText.split(", ")[0];
                                                                const valueState =
                                                                    e.currentTarget.innerText.split(", ")[1];
                                                                const valueZip =
                                                                    e.currentTarget.innerText.split(", ")[2];

                                                                let dataset = this.state.cityStateZip.find(
                                                                    (cityName) =>
                                                                        cityName.city.toLowerCase() === valueCity.toLowerCase() &&
                                                                        cityName.state.toLowerCase() === valueState.toLowerCase() &&
                                                                        cityName.zipCode.toLowerCase() === valueZip.toLowerCase()
                                                                );

                                                                if (dataset !== undefined) {
                                                                    this.setState((prevState) => {
                                                                        let data = Object.assign(
                                                                            {},
                                                                            prevState.data
                                                                        );
                                                                        if (dataset !== undefined) {
                                                                            data.jobCity = dataset.city;
                                                                            data.jobState = valueState;
                                                                            data.jobZip = valueZip;
                                                                            data.shippingCity = dataset.city;
                                                                            data.shippingState = valueState;
                                                                            data.shippingZip = valueZip;
                                                                            data.salesTaxRate = dataset.estimatedCombinedRate;
                                                                        }
                                                                        return { data };
                                                                    });
                                                                }
                                                            }
                                                        }}
                                                        suggestions={
                                                            this.state.cityStateZip.map(
                                                                (city) =>
                                                                    `${city.city}, ${city.state}, ${city.zipCode}`
                                                            ) || []
                                                        }
                                                    />
                                                </div>
                                            </div>

                                            <div className="field-group col-sm-6">
                                                <span className="field-label">State</span>
                                                <DropdownSelect
                                                    name="jobState"
                                                    defaultText={this.state.data.jobState || ""}
                                                    readOnly={this.state.isYardPickup}
                                                    onChange={(e: string) => {
                                                        let value = e;
                                                        this.setState((prevState) => {
                                                            let data = Object.assign({}, prevState.data);
                                                            if (value !== undefined) {
                                                                data.jobState = value;
                                                                data.shippingState = value;
                                                            }
                                                            return { data };
                                                        });

                                                        let dataset = this.state.cityStateZip.find(
                                                            (cityName) => {
                                                                if (this.state.data && this.state.data.jobCity) {
                                                                    return cityName.city.toLowerCase() === this.state.data.jobCity.toLowerCase() &&
                                                                        cityName.state.toLowerCase() === value.toLowerCase();
                                                                }
                                                                return false;
                                                            });

                                                        if (dataset !== undefined) {
                                                            this.setState((prevState) => {
                                                                let data = Object.assign(
                                                                    {},
                                                                    prevState.data
                                                                );
                                                                if (dataset !== undefined) {
                                                                    if (data.jobZip != dataset.zipCode) {
                                                                        data.jobZip = dataset.zipCode;
                                                                        data.shippingZip = dataset.zipCode;
                                                                    }
                                                                    data.salesTaxRate = dataset.estimatedCombinedRate;
                                                                }
                                                                return { data };
                                                            });
                                                        }
                                                    }}
                                                    optionsList={
                                                        (this.groupBy(this.state.cityStateZip, "city")[
                                                            this.state.data.jobCity as string
                                                        ] &&
                                                            this.groupBy(this.state.cityStateZip, "city")
                                                            [
                                                                this.state.data.jobCity as string
                                                            ].filter(
                                                                (value: any, index: any, self: any) =>
                                                                    index ===
                                                                    self.findIndex(
                                                                        (city: any) =>
                                                                            city.state === value.state
                                                                    )
                                                            )
                                                                .reduce((acc: any, current: any) => {
                                                                    acc.push({
                                                                        id: current.city,
                                                                        name: current.state,
                                                                    });
                                                                    return acc;
                                                                }, [])) ||
                                                        []
                                                    }
                                                />
                                            </div>
                                            <div className="field-group col-sm-6">
                                                <span className="field-label">Zip</span>
                                                <DropdownSelect
                                                    name="jobZip"
                                                    defaultText={this.state.data.jobZip || ""}
                                                    readOnly={this.state.isYardPickup}
                                                    onChange={(e) => {
                                                        let value = e;
                                                        this.setState((prevState) => {
                                                            let data = Object.assign({}, prevState.data);
                                                            if (value !== undefined) {
                                                                data.jobZip = value;
                                                                data.shippingZip = value;
                                                            }
                                                            return { data };
                                                        });

                                                        let dataset = this.state.cityStateZip.find(
                                                            (cityName) => {
                                                                if (this.state.data && this.state.data.jobCity && this.state.data.jobState) {
                                                                    return cityName.city.toLowerCase() === this.state.data.jobCity.toLowerCase() &&
                                                                        cityName.state.toLowerCase() === this.state.data.jobState.toLowerCase() &&
                                                                        cityName.zipCode.toLowerCase() === value.toLowerCase();
                                                                }
                                                            });

                                                        if (dataset !== undefined) {
                                                            this.setState((prevState) => {
                                                                let data = Object.assign(
                                                                    {},
                                                                    prevState.data
                                                                );
                                                                if (dataset !== undefined) {
                                                                    data.salesTaxRate = dataset.estimatedCombinedRate;
                                                                }
                                                                return { data };
                                                            });
                                                        }
                                                    }}
                                                    optionsList={
                                                        (this.groupBy(this.state.cityStateZip, "city")[
                                                            this.state.data.jobCity as string
                                                        ] &&
                                                            this.state.data.jobState &&
                                                            this.groupBy(this.state.cityStateZip, "city")
                                                            [
                                                                this.state.data.jobCity as string
                                                            ].filter(
                                                                (arg: any) =>
                                                                    arg.state ===
                                                                    this.state.data.jobState
                                                            )
                                                                .reduce((acc: any, current: any) => {
                                                                    acc.push({
                                                                        id: current.zipCode,
                                                                        name: current.zipCode,
                                                                    });
                                                                    return acc;
                                                                }, [])) ||
                                                        []
                                                    }
                                                ></DropdownSelect>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="field-group col-sm-6 mt-3 mb-3">
                                        <span className="field-label mt-0">Taxable</span>
                                        <p className="custom-checkbox-wrap">
                                            <input
                                                className="custom-checkbox"
                                                id="taxable-yes"
                                                name="isTaxable"
                                                value="true"
                                                type="radio"
                                                checked={this.state.isTaxable}
                                                onChange={this.handleBooleanInputChanged}
                                            />
                                            <label htmlFor="taxable-yes">Yes</label>
                                        </p>
                                        <p className="custom-checkbox-wrap">
                                            <input
                                                className="custom-checkbox"
                                                id="taxable-no"
                                                name="isTaxable"
                                                value="false"
                                                type="radio"
                                                checked={!this.state.isTaxable}
                                                onChange={this.handleBooleanInputChanged}
                                            />
                                            <label htmlFor="taxable-no">No</label>
                                        </p>
                                    </div>

                                    <div className="field-group col-sm-6">
                                        <span className="field-label">Salesperson </span>
                                        <select name="salespersonCode" className="form-control selectbox" style={{ paddingTop: "0", paddingBottom: "0" }}
                                            value={this.state.selectedSalespersonCode}
                                            onChange={this.handleSalespersonChanged} >
                                            <option value="">Select a salesperson</option>
                                            {this.state.salespeople.map((value, index) => (
                                                <option key={index} value={value.code} selected={value.name === this.state.data.salespersonName}>{value.name}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="field-group col-sm-12">
                                        <span className="field-label mt-0">Shipping Method</span>
                                        <p className="custom-radio-wrap">
                                            <input
                                                className="custom-radio"
                                                id="direct"
                                                name="shippingMethod"
                                                type="radio"
                                                value="direct"
                                                onClick={this.handleShippingMethodChanged}
                                                defaultChecked={
                                                    this.state.data.shippingMethod == "direct"
                                                }
                                            />
                                            <label htmlFor="direct">Direct</label>
                                        </p>
                                        <p className="custom-radio-wrap">
                                            <input
                                                className="custom-radio"
                                                id="yard"
                                                name="shippingMethod"
                                                type="radio"
                                                value="yard"
                                                onClick={this.handleShippingMethodChanged}
                                                defaultChecked={
                                                    true
                                                        ? this.state.data.shippingMethod !== "direct"
                                                        : this.state.data.shippingMethod == "yard"
                                                }
                                            />
                                            <label htmlFor="yard">Yard</label>
                                        </p>
                                    </div>

                                    {this.state.data.shippingMethod === "yard" && (
                                        <div className="shippingMethodControl field-group col-sm-12 mb-4">
                                            <span className="field-label"></span>
                                            <div className="field-group__card">
                                                <p className="custom-radio-wrap">
                                                    <input
                                                        className="custom-radio"
                                                        id="pickup"
                                                        name="shippingMethodYard"
                                                        type="radio"
                                                        value="pickup"
                                                        onClick={this.handleShippingMethodYardChanged}
                                                        defaultChecked={
                                                            this.state.data.shippingMethodYard == "pickup"
                                                        }
                                                    />
                                                    <label htmlFor="pickup">Pickup</label>
                                                </p>
                                                <p className="custom-radio-wrap">
                                                    <input
                                                        className="custom-radio"
                                                        id="delivery"
                                                        name="shippingMethodYard"
                                                        type="radio"
                                                        value="delivery"
                                                        onClick={this.handleShippingMethodYardChanged}
                                                        defaultChecked={
                                                            this.state.data.shippingMethodYard == "delivery"
                                                        }
                                                    />
                                                    <label htmlFor="delivery">Delivery</label>
                                                </p>
                                            </div>
                                        </div>
                                    )}

                                    {(this.state.data.shippingMethod === "direct" ||
                                        (this.state.data.shippingMethod === "yard" &&
                                            this.state.data.shippingMethodYard === "delivery")) && (
                                            <div className="shippingMethodAddress field-group col-sm-12 mb-4">
                                                <div className="row">

                                                    <div className="field-group col-sm-6">
                                                        <span className="field-label">Delivery Date</span>
                                                        <input
                                                            className="date-input form-control"
                                                            type="date"
                                                            name="shippingDate"
                                                            onInput={(e: any) => {
                                                                e.target.setAttribute(
                                                                    "data-date",
                                                                    moment(e.target.value, "YYYY-MM-DD").format(
                                                                        e.target.getAttribute("data-date-format")
                                                                    )
                                                                );
                                                            }}
                                                            data-date={moment(new Date()).format(
                                                                "MMMM, DD  YYYY"
                                                            )}
                                                            data-date-format="MMMM, DD  YYYY"
                                                            required
                                                            defaultValue={
                                                                this.state.data.shippingDate
                                                                    ? moment(this.state.data.shippingDate).format("YYYY-MM-DD")
                                                                    : moment(new Date()).format("YYYY-MM-DD")
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    <div className="field-group  col-sm-12">
                                        <span className="field-label">Project Note</span>
                                        <textarea
                                            name="projectNote"
                                            id="projectNote"
                                            rows={6}
                                            cols={3}
                                            className="w-100"
                                            defaultValue={this.state.data.projectNote}
                                        ></textarea>
                                    </div>

                                    <input
                                        style={{ display: "none" }}
                                        name="salesTax1"
                                        className="form-control"
                                        value={
                                            this.state.data.salesTax !== undefined
                                                ? this.state.data.salesTax
                                                : ""
                                        }
                                        role="presentation"
                                    />

                                    <input
                                        style={{ display: "none" }}
                                        name="salesTaxRate1"
                                        className="form-control"
                                        value={
                                            this.state.data.salesTaxRate != undefined
                                                ? this.state.data.salesTaxRate
                                                : (this.state.data.shippingSalesTaxRate !== null ? this.state.data.shippingSalesTaxRate : "")
                                        }
                                        role="presentation"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="button-actions text-center">
                            <button type="submit" className="btn btn-primary">
                                Next (Material Details)
                            </button>
                            {/*<a*/}
                            {/*    href="#"*/}
                            {/*    className="btn-link"*/}
                            {/*    data-toggle="modal"*/}
                            {/*    data-target="#cancel-sales-quote-edit"*/}
                            {/*>*/}
                            {/*    Cancel*/}
                            {/*</a>*/}
                            <button className="btn-link" onClick={this.handleCancel}>
                                Cancel
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    public async componentDidMount() {
        document.title = "Add New Quote to Sales Order - " + SITE_NAME;

        this.state.data.shippingMethod =
            this.props.data && this.props.data.shippingMethod
                ? this.props.data.shippingMethod
                : "yard";
        this.state.data.shippingMethodYard =
            this.props.data && this.props.data.shippingMethodYard
                ? this.props.data.shippingMethodYard
                : "pickup";

        //default shipping Address
        if (this.state.data.jobCustomerAddress) {
            this.state.data.shippingAddress = this.state.data.jobCustomerAddress.address;
        } else {
            if (this.state.data.id == 0) {
                this.state.data.shippingAddress = this.state.data.jobAddress;
            }
        }

        await this.getCityStateZip();

        await this.getSalesPeople();

    }

    private async getCityStateZip() {
        const res = await apifetch(
            `quotes/lookupAddress?cityPart=${this.state.data.jobCity}`,
            undefined,
            true
        );
        if (res.ok) {
            const data = await res.json();
            if (data) {
                this.setState({
                    cityStateZip: [...data],
                });
            }
        } else {
            const errorText = await extractErrorMessage(res);
            this.setState({ errorMessage: errorText });
        }
    }
    private async getSalesPeople() {

        this.setState({ errorMessage: undefined });
        let response = await apifetch("quotes/salespeople", undefined, true);
        if (response.ok) {

            let data = await response.json() as SalesPerson[];

            let selectedSalespersonCode = '';
            const selectedSalesperson = data.find(salesperson => salesperson.name === this.state.data.salespersonName);
            if (selectedSalesperson) {
                selectedSalespersonCode = selectedSalesperson.code;
            }

            this.setState({
                salespeople: data,
                selectedSalespersonCode: selectedSalespersonCode,
            });
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({ errorMessage: errorText });
        }
    }

    private groupBy(arr: any, key: string) {
        const initialValue = {};
        return arr.reduce((acc: any, cval: any) => {
            const myAttribute = cval[key];
            acc[myAttribute] = [...(acc[myAttribute] || []), cval];
            return acc;
        }, initialValue);
    }

    private doNothing(e: React.FormEvent<HTMLAnchorElement>) {
        e.preventDefault();
    }

    private handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        if (this.state.data.shippingMethod === "direct" || this.state.data.shippingMethodYard === "delivery") {

            //const elementCustomerContacts = document.getElementsByName('customerContactName');
            //Array.from(elementCustomerContacts).forEach(element => {
            //    element.style.boxShadow = '0 0 1.5px 1px red';
            //});

            //const elementPhones = document.getElementsByName('phone');
            //Array.from(elementPhones).forEach(element => {
            //    element.style.boxShadow = '0 0 1.5px 1px red';
            //});

            //if (!this.state.data.jobAddress || this.state.data.jobAddress.trim() === '') {
            //    const elements = document.getElementsByName('jobAddress');
            //    Array.from(elements).forEach(element => {
            //        element.style.boxShadow = '0 0 1.5px 1px red';
            //    });
            //    return;
            //}
            //if (!this.state.data.jobCity || this.state.data.jobCity.trim() === '') {
            //    const elements = document.getElementsByName('jobCity');
            //    Array.from(elements).forEach(element => {
            //        element.style.boxShadow = '0 0 1.5px 1px red';
            //    });
            //    return;
            //}

            //if (!this.state.data.jobState || this.state.data.jobState.trim() === '') {
            //    const elements = document.getElementsByName('jobState');
            //    Array.from(elements).forEach(element => {
            //        element.style.boxShadow = '0 0 1.5px 1px red';
            //    });
            //    return;
            //}

            //if (!this.state.data.jobZip || this.state.data.jobZip.trim() === '' || isNaN(Number(this.state.data.jobZip))) {
            //    const elements = document.getElementsByName('jobZip');
            //    Array.from(elements).forEach(element => {
            //        element.style.boxShadow = '0 0 1.5px 1px red';
            //    });
            //    return;
            //}

            //const matchFound = this.state.cityStateZip.some(entry =>
            //    entry.city.toLowerCase() === this.state.data.jobCity.trim().toLowerCase() &&
            //    entry.state.toLowerCase() === this.state.data.jobState.trim().toLowerCase() &&
            //    entry.zipCode === this.state.data.jobZip.trim()
            //);
            const { jobAddress, jobCity, jobState, jobZip } = this.state.data;

            if (!jobAddress || jobAddress.trim() === '') {
                const elements = document.getElementsByName('jobAddress');
                Array.from(elements).forEach(element => {
                    element.style.boxShadow = '0 0 1.5px 1px red';
                });
                return;
            }

            if (!jobCity || jobCity.trim() === '') {
                const elements = document.getElementsByName('jobCity');
                Array.from(elements).forEach(element => {
                    element.style.boxShadow = '0 0 1.5px 1px red';
                });
                return;
            }

            if (!jobState || jobState.trim() === '') {
                const elements = document.getElementsByName('jobState');
                Array.from(elements).forEach(element => {
                    element.style.boxShadow = '0 0 1.5px 1px red';
                });
                return;
            }

            if (!jobZip || jobZip.trim() === '' || isNaN(Number(jobZip))) {
                const elements = document.getElementsByName('jobZip');
                Array.from(elements).forEach(element => {
                    element.style.boxShadow = '0 0 1.5px 1px red';
                });
                return;
            }

            ////note (TASK 811): commented out because uesr can enter any city, state and zip of their choice
            //const trimmedCity = jobCity.trim().toLowerCase();
            //const trimmedState = jobState.trim().toLowerCase();
            //const trimmedZip = jobZip.trim();

            //const matchFound = this.state.cityStateZip.some(entry =>
            //    entry.city.toLowerCase() === trimmedCity &&
            //    entry.state.toLowerCase() === trimmedState &&
            //    entry.zipCode === trimmedZip
            //);

            //if (!matchFound) {
            //    ['jobCity', 'jobState', 'jobZip'].forEach(name => {
            //        const elements = document.getElementsByName(name);
            //        Array.from(elements).forEach(element => {
            //            element.style.boxShadow = '0 0 1.5px 1px red';
            //        });
            //    });
            //    return;
            //}

        } else {
            this.resetShippingAddressBorder();
        }

        let data = serialize(e.currentTarget, { hash: true }) as any;


        if (data.phone) {
            data.phone = normalizePhone(data.phone);
        }
        data.quoteName = this.state.data.quoteName;
        data.jobId = this.state.data.jobId;
        data.jobName = this.state.data.jobName;
        data.jobAddress = this.state.data.jobAddress;
        data.jobCity = this.state.data.jobCity;
        data.jobState = this.state.data.jobState;
        data.jobZip = this.state.data.jobZip;

        data.shippingMethod = this.state.data.shippingMethod;
        data.shippingMethodYard = this.state.data.shippingMethodYard;
        data.shippingAddress = this.state.data.shippingAddress;
        data.shippingCity = this.state.data.shippingCity;
        data.shippingState = this.state.data.shippingState;
        data.shippingZip = this.state.data.shippingZip;
        data.cityStateZip = this.state.cityStateZip;

        data.isTaxable = this.state.isTaxable;

        if (data.salespersonCode !== undefined) {
            let salesperson = this.state.salespeople.find(x => x.code == data.salespersonCode);
            if (salesperson) {
                data.salespersonName = salesperson.name;
            }
        }

        data.isYardPickup = this.state.isYardPickup;

        this.props.onSubmit(data)
    }

    private resetShippingAddressBorder() {
        //const elementCustomerContacts = document.getElementsByName('customerContactName');
        //Array.from(elementCustomerContacts).forEach(element => {
        //    element.style.boxShadow = '';
        //});

        //const elementPhones = document.getElementsByName('phone');
        //Array.from(elementPhones).forEach(element => {
        //    element.style.boxShadow = '';
        //});

        const elementJobAddresses = document.getElementsByName('jobAddress');
        Array.from(elementJobAddresses).forEach(element => {
            element.style.boxShadow = '';
        });

        const elementJobCities = document.getElementsByName('jobCity');
        Array.from(elementJobCities).forEach(element => {
            element.style.boxShadow = '';
        });

        const elementJobStates = document.getElementsByName('jobState');
        Array.from(elementJobStates).forEach(element => {
            element.style.boxShadow = '';
        });

        const elementJobZips = document.getElementsByName('jobZip');
        Array.from(elementJobZips).forEach(element => {
            element.style.boxShadow = '';
        });
    }

    private handleCancel(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        this.props.onCancel();
    }

    private handleShippingMethodChanged(e: any) {
        const value = e.target.value;
        this.setState((prevState) => {
            let data = Object.assign({}, prevState.data);
            let isYardPickup = value === 'yard';

            if (data.shippingMethod !== value) {
                data.shippingMethod = value;
                data.shippingAddress = data.jobAddress;
                data.shippingCity = data.jobCity;
                data.shippingState = data.jobState;
                data.shippingZip = data.jobZip;

                if (value === 'yard') {
                    data.shippingSalesTaxRate = data.defaultYardShippingSalesTaxRate;
                    if (data.shippingMethodYard === "pickup") {
                        isYardPickup = true;
                        this.resetShippingAddressBorder();
                    } else {
                        isYardPickup = false;
                    }
                } else {
                    data.shippingSalesTaxRate = null;
                }
            }
            return {
                data,
                isYardPickup: isYardPickup
            };
        });
    }

    private handleShippingMethodYardChanged(e: any) {
        const value = e.target.value;
        this.setState((prevState) => {
            let data = Object.assign({}, prevState.data);
            let isYardPickup = value === 'pickup';

            if (data.shippingMethodYard !== value) {
                data.shippingMethodYard = value;
                data.shippingAddress = data.jobAddress;
                data.shippingCity = data.jobCity;
                data.shippingState = data.jobState;
                data.shippingZip = data.jobZip;

                if (value === 'pickup') {
                    data.shippingSalesTaxRate = data.defaultYardShippingSalesTaxRate;
                    this.resetShippingAddressBorder();
                } else {
                    data.shippingSalesTaxRate = null;
                }
            }
            return {
                data,
                isYardPickup: isYardPickup
            };
        });
    }

    private handleBooleanInputChanged(
        event: React.SyntheticEvent<HTMLInputElement>
    ) {
        this.setState({
            [event.currentTarget.name]: event.currentTarget.value === "true",
        } as any);
    }

    private async handleSalespersonChanged(e: any) {
        this.setState({
            selectedSalespersonCode: e.target.value,
        });
    }

    private async handleJobChanged(selectedOption: any) {
        // Check if an option is selected
        if (!selectedOption) {
            this.setState({ selectedJobCustomerAddress: null });
            return;
        }

        const jobId = selectedOption.value;

        let jobCustomerAddress = this.state.data.jobCustomerAddresses.find(prj => prj.jobId === jobId);

        if (jobCustomerAddress) {

            const updatedData = {
                ...this.state.data,
                jobId: jobCustomerAddress.jobId,
                jobName: jobCustomerAddress.jobName,
                jobAddress: jobCustomerAddress.address,
                jobCity: jobCustomerAddress.city,
                jobState: jobCustomerAddress.state,
                jobZip: jobCustomerAddress.zip,
                shippingAddress: jobCustomerAddress.address,
                shippingCity: jobCustomerAddress.city,
                shippingState: jobCustomerAddress.state,
                shippingZip: jobCustomerAddress.zip,
            };

            this.setState({
                isJobSelected: true,
                selectedJobCustomerAddress: jobCustomerAddress,
                data: updatedData,
                isTaxable: jobCustomerAddress.taxLiable,
            });

            await this.getCityStateZip();
        }
    }

    private handleJobAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newAddress = e.target.value;
        this.setState({
            data: { ...this.state.data, jobAddress: newAddress, shippingAddress: newAddress }
        });
    };

    private async handleShippingCitySelected(e: any) {

        let value = e.target.value;
        this.setState((prevState) => {
            let data = Object.assign({}, prevState.data);
            data.shippingCity = value;
            return { data };
        });

        await this.getCityStateZip();

        if (!!value) {
            let newCityList = this.state.cityStateZip;

            let dataset = newCityList.find(
                (cityName) => cityName.city.toLowerCase() === value.toLowerCase()
            );

            this.state.data.salesTax = 49;

            if (dataset === undefined) {
                this.setState((prevState) => {
                    let data = Object.assign({}, prevState.data);
                    if (dataset === undefined) {
                        data.shippingState = " ";
                        data.shippingZip = " ";
                        data.salesTax = 0;
                    }
                    return { data };
                });
            }
        }
    }

    private async handleJobCitySelected(e: any) {
        let value = e.target.value;

        this.setState((prevState) => {
            let data = Object.assign({}, prevState.data);
            data.jobCity = value;
            data.shippingCity = value;
            return { data };
        });

        await this.getCityStateZip();

        if (!!value) {
            let newCityList = this.state.cityStateZip;

            let dataset = newCityList.find(
                (cityName) => cityName.city.toLowerCase() === value.toLowerCase()
            );

            this.state.data.salesTax = 49;

            if (dataset === undefined) {
                this.setState((prevState) => {
                    let data = Object.assign({}, prevState.data);
                    if (dataset === undefined) {
                        data.jobState = " ";
                        data.shippingState = " ";
                        data.shippingZip = " ";
                        data.jobZip = " ";
                        data.salesTax = 0;
                    }
                    return { data };
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/quotes/SalesOrderStep1.tsx